import React from 'react';
import Link from 'components/Link';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import ImageV2 from 'components_v2/common/ImageV2';
import { getImageFromImageObject } from 'components/Image/utils';
import s from './TOIAssistHPWidget.scss';

function customOnError(e) {
  e.target.onerror = null;
  e.target.src = 'https://static.toiimg.com/photo/25581306.cms';
}

const TOIAssistHPWidget = props => {
  const { data, isPrime } = props;
  if (!(data && Array.isArray(data.items) && data.items.length >= 3)) {
    return null;
  }

  const { items } = data;

  const botNames = items.map(
    item => (item.botname ? item.botname.toLowerCase() : ''),
  );
  const botsShown = botNames.join(',');

  const bodystruct = {
    version: 'website_03Jul2023',
    type: 'redirect',
    l_bot_shown: botsShown,
  };

  const slot_name = 'toi_hp_top_rhs_widget';

  const sendClickGrx = botName => {
    const clickBodyStruct = {
      ...bodystruct,
      bot_click: botName,
    };
    setTimeout(() => {
      analyticsWrapper('grx', 'track', 'TOIAssist_WidgetClick', {
        slot_name,
        body: JSON.stringify(clickBodyStruct),
      });
    }, 3000);
  };

  return (
    <InViewObserver
      inViewCallback={() => {
        setTimeout(() => {
          analyticsWrapper('grx', 'track', 'TOIAssist_WidgetView', {
            slot_name,
            body: JSON.stringify(bodystruct),
          });
        }, 5000);
      }}
    >
      <div className={`${s.taRhsWrapper} ${isPrime ? s.removeMargin : ''}`}>
        <Link
          to={`https://www.timesassist.com/?refer_type=${
            props.isWapView ? 'mweb' : 'web'
          }&refer_template=homepage`}
          target="_blank"
          onClick={() => {
            setTimeout(() => {
              analyticsWrapper('grx', 'track', 'TOIAssist_WidgetClick', {
                slot_name: `${slot_name}_title`,
                body: JSON.stringify(bodystruct),
              });
            }, 3000);
          }}
          className={s.taNewSlug}
        >
          NEW
        </Link>
        <Link
          to={`https://www.timesassist.com/?refer_type=${
            props.isWapView ? 'mweb' : 'web'
          }&refer_template=homepage`}
          target="_blank"
          onClick={() => {
            setTimeout(() => {
              analyticsWrapper('grx', 'track', 'TOIAssist_WidgetClick', {
                slot_name: `${slot_name}_title`,
                body: JSON.stringify(bodystruct),
              });
            }, 3000);
          }}
          className={s.taRhsHeading}
        >
          Try our new TOI+ offering: Chat with Times Assist
        </Link>
        <div className={s.taRhsStoriesWrapper}>
          {Array.isArray(items) &&
            items.length >= 3 &&
            items.slice(0, 3).map(item => {
              const { imageid = '', imagesize = '123456', imageUrl } = item;
              const { image = {} } = item;

              image.width = '80';
              image.id = imageid || image.id;
              image.version = imagesize || image.version;

              const imageSrc = getImageFromImageObject(image) || imageUrl;
              return (
                <Link
                  to={item.wu}
                  target="_blank"
                  onClick={() => {
                    sendClickGrx(item.botname);
                  }}
                  className={s.taRhsStories}
                >
                  <div className={s.taRhsStoriesText}>{item.hl}</div>
                  <div className={s.taRhsStoriesImg}>
                    <ImageV2
                      key={data.id}
                      width="80"
                      src={imageSrc}
                      placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                      alt={item.botname}
                      lazyload
                      onError={customOnError}
                      offsetVertical={300}
                    />
                  </div>
                </Link>
              );
            })}
        </div>
      </div>
    </InViewObserver>
  );
};

export default TOIAssistHPWidget;
